import React, { useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import Button from "./ui/Button";
import useScrollPosition from "../hooks/useScrollPosition";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

const BackToTopButton = () => {
  const isVisible = useScrollPosition(480);
  const prefersReducedMotion = usePrefersReducedMotion();

  const handleClick = useCallback(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  }, [prefersReducedMotion]);

  return (
    <AnimatePresence>
      {isVisible ? (
        <motion.div
          className="pointer-events-none fixed bottom-[calc(env(safe-area-inset-bottom)+1rem)] right-3 z-40 sm:bottom-6 sm:right-6"
          initial={prefersReducedMotion ? false : { opacity: 0, y: 18, scale: 0.96 }}
          animate={prefersReducedMotion ? { opacity: 1 } : { opacity: 1, y: 0, scale: 1 }}
          exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 12, scale: 0.96 }}
          transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
        >
          <Button
            type="button"
            variant="outline"
            onClick={handleClick}
            aria-label="Back to top"
            className="pointer-events-auto h-11 w-11 rounded-full border-primary/70 bg-background/92 px-0 text-foreground shadow-card-hover backdrop-blur supports-[backdrop-filter]:bg-background/82 sm:h-12 sm:w-auto sm:px-5"
          >
            <ArrowUp className="h-4 w-4" aria-hidden="true" />
            <span className="hidden text-quiet-action sm:inline">Back to top</span>
          </Button>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default BackToTopButton;
